import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';

import { dateTR, payMethodLabel } from '../../../utils/memberDetailUtils';
import { money } from 'sectors/pilates/members/components/paymentReceive/ui';

function safe(v, fallback = '—') {
  const s = (v ?? '').toString().trim();
  return s ? s : fallback;
}

export function PaymentDetailModal({ open, onClose, payment }) {
  const p = payment || null;
  const planName = p?.planNameLive || p?.planNameSnapshot || '—';
  const planStart = p?.planStartAt || p?.planPlannedStartAt || '—';

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <MDBox>
          <MDTypography fontWeight="bold">Ödeme Detayı</MDTypography>
          <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
            #{p?.id ?? '—'} • {dateTR(p?.createdAt)}
          </MDTypography>
        </MDBox>

        <IconButton onClick={onClose}>
          <Icon>close</Icon>
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <MDBox sx={{ display: 'grid', gap: 1 }}>
          <MDBox>
            <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
              Tutar
            </MDTypography>
            <MDTypography fontWeight="bold">{money(Number(p?.amountTry || 0))}</MDTypography>
          </MDBox>

          <Divider />

          <MDBox sx={{ display: 'grid', gap: 0.6 }}>
            <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
              Amaç
            </MDTypography>
            <MDTypography fontWeight="bold">{safe(p?.purpose)}</MDTypography>

            <MDTypography variant="caption" sx={{ color: 'text.secondary', mt: 0.5 }}>
              Ödeme Yöntemi
            </MDTypography>
            <MDTypography fontWeight="bold">{payMethodLabel(p?.method)}</MDTypography>

            <MDTypography variant="caption" sx={{ color: 'text.secondary', mt: 0.5 }}>
              Ödeme Tarihi
            </MDTypography>
            <MDTypography fontWeight="bold">{safe(p?.paidDate)}</MDTypography>

            <MDTypography variant="caption" sx={{ color: 'text.secondary', mt: 0.5 }}>
              Alan
            </MDTypography>
            <MDTypography fontWeight="bold">{safe(p?.receivedByName)}</MDTypography>

            {p?.approvedByName ? (
              <>
                <MDTypography variant="caption" sx={{ color: 'text.secondary', mt: 0.5 }}>
                  Onaylayan
                </MDTypography>
                <MDTypography fontWeight="bold">
                  {safe(p?.approvedByName)} • {dateTR(p?.approvedAt)}
                </MDTypography>
              </>
            ) : null}
          </MDBox>

          <Divider />

          <MDBox sx={{ display: 'grid', gap: 0.6 }}>
            <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
              Paket Bilgisi
            </MDTypography>
            <MDTypography fontWeight="bold">{planName}</MDTypography>

            <MDTypography variant="caption" sx={{ color: 'text.secondary', mt: 0.5 }}>
              Paket Başlangıç
            </MDTypography>
            <MDTypography fontWeight="bold">{safe(planStart)}</MDTypography>

            <MDTypography variant="caption" sx={{ color: 'text.secondary', mt: 0.5 }}>
              Paket Durumu
            </MDTypography>
            <MDTypography fontWeight="bold">{safe(p?.planStatus)}</MDTypography>
          </MDBox>

          {String(p?.note || '').trim() ? (
            <>
              <Divider />
              <MDBox>
                <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
                  Not
                </MDTypography>
                <MDTypography fontWeight="bold">{safe(p?.note)}</MDTypography>
              </MDBox>
            </>
          ) : null}
        </MDBox>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <MDButton onClick={onClose} color="dark" variant="outlined">
          Kapat
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
